import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { FUNCTION_SPECS } from '../../shared/formula/functionRegistry';

const FUNCTIONS_WITH_HELP = FUNCTION_SPECS.filter((spec) => spec.help);

// Functions per menu heading, in registry order.
const GROUPS = FUNCTIONS_WITH_HELP.reduce((groups, spec) => {
    const group = spec.help.group ?? 'Other';
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group).push(spec);
    return groups;
}, new Map());

/**
 * "Insert function" menu with the formula functions from the shared function
 * registry, grouped, each with its description and example. Choosing one
 * inserts its template at the cursor in the formula.
 */
const FormulaFunctions = ({ onInsert }) => {
    if (FUNCTIONS_WITH_HELP.length === 0) return null;

    const byName = new Map(FUNCTIONS_WITH_HELP.map((spec) => [spec.name, spec]));

    const menu = (
        <Menu className="formula-functions-menu" onClick={({ key }) => onInsert(byName.get(key).help.template)}>
            {[...GROUPS].map(([group, specs]) => (
                <Menu.ItemGroup key={group} title={group}>
                    {specs.map((spec) => (
                        <Menu.Item key={spec.name}>
                            <code className="formula-functions-signature">{spec.help.signature}</code>
                            <div className="formula-functions-description">{spec.help.description}</div>
                            {spec.help.example && (
                                <div className="formula-functions-example">
                                    Example: <code>{spec.help.example}</code>
                                </div>
                            )}
                        </Menu.Item>
                    ))}
                </Menu.ItemGroup>
            ))}
        </Menu>
    );

    return (
        <div className="formula-functions">
            <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
                <Button size="small">
                    Insert function <DownOutlined />
                </Button>
            </Dropdown>
        </div>
    );
};

export default FormulaFunctions;
